var isFirstStep = function isFirstStep(stepStatus) {
  return stepStatus.stepNumber === 1;
};

var isActivityStart = function isActivityStart(stepStatus) {
  return isFirstStep(stepStatus) && !stepStatus.completed;
};

export var stepStatusModel = {
  isFirstStep: isFirstStep,
  isActivityStart: isActivityStart
};